<template>
<div style="background: #f8f8f8">
    <!--Alerta verde en la parte superior derecha -->
    <b-alert
      v-if="statusMessage"
      show
      variant="success"
      class="fixed-alert"
      dismissible
      @dismissed="statusMessage = ''"
    >
      {{ statusMessage }}
    </b-alert>
    <div>
        <b-row style="max-width: 100%">
            <b-col xs="12" sm="12" md="12" lg="4" class="padding-five-tb">
                <h5 class="color-gray padding-ten-lr">Consulta por Ticket</h5>
            </b-col>
        </b-row>
    </div>
    <section>
        <b-container>
            <b-row>
                <b-col cols="10" class="center-col bg-white border-radius-20">
                    <b-row>
                        <b-col lg="12" class="padding-five-lr">
                            <h5 class="color-orange padding-two-bottom text-med">
                                Búsqueda
                            </h5>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col lg="5">
                            <b-row>
                                <b-col cols="12">
                                    <label class="">FECHA DE COMPRAS</label>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" md="6" lg="6" class="padding-six-xs">
                                    <b-form-input aria-required required type="date" v-model="fechaInicio" size="lg"></b-form-input>
                                </b-col>
                                <b-col cols="12" md="6" lg="6">
                                    <b-form-input aria-required required type="date" size="lg" v-model="fechaFin"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col lg="4">
                            <label> LOCAL</label>
                            <b-form-select v-model="sucursal" size="lg" :options="optionStores">
                            </b-form-select>
                        </b-col>
                        <b-col lg="3" style="text-align: center">
                            <label class="visibility-hidden" style="display: block">Fecha Fin
                            </label>
                            <b-button @click="getData" class="bg-orange-btn width-1000" size="lg" :disabled="isSelected">
                                <font-awesome-icon icon="search" /> Buscar
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="padding-none-lr">
                            <b-button v-b-toggle.collapse-100 class="btn-transparent padding-five-bottom">
                                Opciones avanzadas
                                <span class="when-opened">
                                    <font-awesome-icon icon="chevron-up" />
                                </span>
                                <span class="when-closed">
                                    <font-awesome-icon icon="chevron-down" />
                                </span>
                            </b-button>
                            <b-collapse id="collapse-100">
                                <b-card class="bg-grey">
                                    <b-row>
                                        <b-col cols="12" md="5" lg="5">
                                            <b-row>
                                                <b-col cols="12" lg="6">
                                                    <label>NÚMERO DE CAJA </label>
                                                    <b-form-input aria-required required type="text" v-model="paramsValues.terminal" size="lg"></b-form-input>
                                                    <b-form-text v-if="isSelected">
                                                        Obligatorio
                                                    </b-form-text>
                                                </b-col>
                                                <b-col cols="12" lg="6">
                                                    <label>SECUENCIA</label>
                                                    <b-form-input aria-required required type="text" v-model="paramsValues.sequence" size="lg"></b-form-input>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="12" lg="4">
                                            <label>TIPO DE CONSULTA</label>
                                            <b-dropdown id="dropdown-1" dropdown :text="selectedParamsText" block size="lg" class="bg-transparent" menu-class="w-100 btn-to" toggle-class="btn-to">
                                                <b-dropdown-item v-for="optionsParam in optionsParams" :key="optionsParam.id" @click="setValue(optionsParam)">{{ optionsParam.text }}</b-dropdown-item>
                                                <b-dropdown id="dropdown-2" dropright text="Consulta por Tipo TRX" class="m-2 bg-transparent" menu-class="w-100 btn-to" toggle-class="btn-to" block>
                                                    <b-dropdown-item @click="setValueTRXVenta">Venta</b-dropdown-item>
                                                    <b-dropdown-item @click="setValueTRXNC">Nota Credito</b-dropdown-item>
                                                </b-dropdown>
                                            </b-dropdown>
                                        </b-col>
                                        <b-col cols="12" lg="3">
                                            <b-form-group v-if="selectedParams == 'a'" label="EAN">
                                                <b-form-input type="text" size="lg" v-model="paramsValues.ean"></b-form-input>
                                            </b-form-group>
                                            <b-form-group v-else-if="selectedParams == 'b'" label="SKU">
                                                <b-form-input type="text" size="lg" v-model="paramsValues.sku"></b-form-input>
                                            </b-form-group>
                                            <b-form-group v-else-if="selectedParams == 'c'" label="Documento">
                                                <b-form-input type="text" size="lg" v-model="paramsValues.docIdentidad"></b-form-input>
                                            </b-form-group>
                                            <b-form-group v-else-if="selectedParams == 'f'" label="Cotiz. DAD">
                                                <b-form-input type="text" size="lg" v-model="paramsValues.nv"></b-form-input>
                                            </b-form-group>
                                            <b-form-group v-else-if="selectedParams == 'h'" label="Nro. Factura">
                                                <b-form-input type="text" size="lg" v-model="paramsValues.folio"></b-form-input>
                                            </b-form-group>
                                            <b-form-group v-else-if="selectedParams == 'i'" label="Tipo TRX">
                                                <b-form-input type="text" size="lg" v-model="paramsValues.tipoTRX"></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-collapse>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </section>
    <section class="padding-seven-lr">
        <b-container fluid>
            <b-row>
                <b-col cols="12" class="padding-five-tb" style="padding-left: 0">
                    <h5 class="color-orange text-med">Resultados</h5>
                </b-col>
            </b-row>
            <b-row v-if="isData" class="padding-five-tb show-xs">
            <b-col md="3" lg="3" style="text-align: center" class="hidden-icon">
                <b-button @click="generateExcelFile" class="bg-orange-btn width-1000">
                    <font-awesome-icon icon="search" /> Exportar
                </b-button>
            </b-col>
            </b-row>

            <!-- Si no hay datos -->
            <b-row v-if="!isData">
            <b-col cols="12" class="bg-white text-center padding-five-tb box-shadow-light">
                <p class="text-grey text-large">
                Busca en la parte superior el detalle de venta que necesites
                </p>
            </b-col>
            </b-row>
            <b-row v-else>
                <b-col cols="12" class="bg-white border-radius-20">
                    <!-- Main table element -->
                    <div class="padding-nine-lr">
                        <b-table class="hidden-xs" show-empty :busy="isBusy" small stacked="md" :items="itemTest" :fields="fields" :current-page="currentPage" :per-page="0" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" thead-class="hidden_header">
                            <!-- Scoped slot para la columna urL_SOVOS -->                            
                            <template #cell(urL_SOVOS)="data">
                                <a
                                    v-if="data.item.urL_SOVOS"
                                    :href="data.item.urL_SOVOS"
                                    :download="data.item.heD_NUMDOCDEL"
                                    target="_blank"
                                    rel="noopener"
                                >
                                    Descargar Documento
                                </a>
                                <span v-else>Sin Documento</span>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <b-button size="sm" @click="getDetails(row.item, $event.target)" class="mr-1 btn-orange-tra">
                                    Ver detalle
                                </b-button>
                            </template>
                        </b-table>
                        <b-table class="show-xs" show-empty :busy="isBusy" :items="itemTest" :fields="fieldsTab" :current-page="currentPage" :per-page="0" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
                            <!-- Scoped slot para la columna urL_SOVOS -->
                            <template #cell(urL_SOVOS)="data">
                                <a :href="data.item.urL_SOVOS" target="_blank" rel="noopener">
                                    Ver documento
                                </a>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                            <template v-slot:cell(actions)="row">
                                <b-button style="
                      background: transparent;
                      color: #545b62;
                      border-color: transparent;
                    " size="sm" @click="row.toggleDetails">
                                    <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
                                </b-button>
                            </template>
                            <template #row-details="row">
                                <b-card>
                                    <b-row>
                                        <b-col cols="12" class="text-sm-right">
                                            <label class="text-grey" style="display: inline" for="">F. Proceso:
                                            </label>
                                            <span>{{ row.item.heD_FPROCESO }} </span>
                                        </b-col>
                                        <b-col cols="12" class="text-sm-right">
                                            <label class="text-grey" style="display: inline" for="">F. Compra:
                                            </label>
                                            <span>{{ row.item.heD_FCONTABLE }} </span>
                                        </b-col>
                                        <b-col cols="12" class="text-sm-right">
                                            <label class="text-grey" style="display: inline" for="">Local:</label>
                                            <span>{{ row.item.heD_LOCAL }} </span></b-col>
                                        <b-col cols="12" class="text-sm-right">
                                            <label class="text-grey" style="display: inline" for="">T. Transacción:</label>
                                            <span>{{ row.item.heD_TIPODOC }} </span></b-col>
                                        <b-col cols="12" class="text-sm-right">
                                            <label class="text-grey" style="display: inline" for="">Total:</label>
                                            <span>{{ row.item.heD_TOTAL }} </span></b-col>
                                        <b-col cols="12" class="text-sm-right">
                                            <label class="text-grey" style="display: inline" for="">Ser. Electrónica:</label>
                                            <span>{{ row.item.heD_NUMDOCDEL }} </span></b-col>
                                    </b-row>
                                </b-card>
                                <b-row>
                                    <b-col cols="12">
                                        <b-button size="lg" @click="getDetails(row.item, $event.target)" class="mr-1 btn-orange-tra width-100">
                                            Ver detalle
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="isData" class="padding-five-tb hidden-icon">
                <b-col md="2">
                    <p></p>
                </b-col>
                <b-col md="2" style="display: flex; justify-content: center">
                    <div class="box">
                        <p class="op-84" style="margin-bottom: 0">
                            {{ itemTest.length }} Resultados
                        </p>
                    </div>
                </b-col>
                <b-col cols="2" md="2" style="display: flex; justify-content: center">
                    <div class="box">
                        <p style="margin-bottom: 0">Mostrar</p>
                    </div>
                </b-col>
                <b-col cols="10" md="3" lg="3" style="text-align: left">
                    <b-pagination hide-goto-end-buttons v-model="currentPage" :total-rows="total" :per-page="perPage" pills align="center" size="md" class="my-0"></b-pagination>
                </b-col>
                <b-col md="3" lg="3" style="text-align: center">
                    <small class="text-danger mb-2">
                        Puede generar reportes de hasta <b>2 días</b>.
                    </small>
                    <b-button @click="generateExcelFile" class="bg-orange-btn width-1000">
                        <font-awesome-icon icon="file-excel" /> Generar Excel
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </section>
</div>
</template>

<script>
import axios from "axios";
export default {
    name: "SearchByTicket",
    data() {
        return {
            // Estado para generar Excel
            jobId: null,
            isGenerating: false,
            isReady: false,
            statusMessage: "",
            errorMessage: "",
            pollingInterval: null,
            generatedReports: [],

            //Otros Filtros
            isDropdown2Visible: false,
            paramsValues: {
                sequence: "",
                ean: "",
                terminal: "",
                sku: "",
                cuenta: "",
                nv: "",
                docIdentidad: "",
                tipoTRX: "",
                folio: "",
            },
            optionStores: [{
                value: null,
                text: "Elija una sucursal"
            }],
            sucursal: "",
            fechaInicio: new Date().toISOString().slice(0, 8) + "01",
            fechaFin: new Date().toISOString().substr(0, 10),
            optionsStates: [
                { value: "b", text: "INGRESADA" },
                { value: "c", text: "COORDINADA" },
                { value: "d", text: "REALIZADA" },
            ],
            valueParams: "a",
            selectedParams: "a",
            selectedState: "b",
            valueDate: "Hoy",
            optionsParams: [
                { value: "a", text: "Consulta por producto EAN" },
                { value: "b", text: "Consulta por SKU" },
                { value: "c", text: "Consulta por Documento" },
                { value: "f", text: "Consulta por Cotiz. DAD" },
                { value: "h", text: "Consulta por Nro. Factura" },
            ],
            fechas: ["Hoy", "Ayer", "Tomatoes", "Corn"],
            isBusy: false,
            detailsOS: {},
            tag: "",
            itemTest: [],
            fields: [
                { key: "heD_FPROCESO", label: "F. Proceso", thClass: "text-center", tdClass: "text-center" },
                { key: "heD_FCONTABLE", label: "F. Compra", thClass: "text-center", tdClass: "text-center" },
                { key: "heD_LOCAL", label: "Local", thClass: "text-center", tdClass: "text-center" },
                { key: "heD_POS", label: "Caja", thClass: "text-center", tdClass: "text-center" },
                { key: "heD_NUMTRX", label: "Secuencia", thClass: "text-center", tdClass: "text-center" },
                { key: "heD_TIPODOC", label: "T. Transacción", thClass: "text-center", tdClass: "text-center" },
                { key: "heD_TOTAL", label: "Total", thClass: "text-center", tdClass: "text-center" },
                { key: "heD_NUMDOCDEL", label: "Ser. Electrónica", thClass: "text-center", tdClass: "text-center" },
                { key: "urL_SOVOS", label: "Ver PDF", thClass: "text-center", tdClass: "text-center" },
                { key: "actions", label: "", thClass: "text-center", tdClass: "text-center" },
            ],
            fieldsTab: [
                { key: "actions", label: "" },
                { key: "heD_POS", label: "Caja" },
                { key: "heD_NUMTRX", label: "Secuencia"},
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            sortBy: "",
            sortDesc: false,
            sortDirection: "asc",
            filter: null,
            filterOn: [],
            infoModal: {
                id: "info-modal",
                title: "",
                content: "",
            },
            dataDashboard: {},
            selectedParamsText: "Consulta por producto EAN",
            limit: 10,
            countRecords: 20,
        };
    },
    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        },
        isData() {
            if (this.itemTest.length > 0) return true;
            return false;
        },
        rows() {
            return this.itemTest.length;
        },
        isSelected() {
            if (this.selectedParams === "h" && this.paramsValues.terminal.length == 0)
                return true;
            return false;
        },
        total() {
            if (this.currentPage == 1 && this.itemTest.length < 10) return 10;
            return this.countRecords;
        },
    },
    mounted() {
        // Set the initial number of items
        this.$root.$on("bv::dropdown::show", (bvEvent) => {
            if (bvEvent.componentId === "dropdown-2") {
                this.isDropdown2Visible = true;
            }
        });
        this.$root.$on("bv::dropdown::hide", (bvEvent) => {
            if (bvEvent.componentId === "dropdown-2") {
                this.isDropdown2Visible = false;
            }
            if (this.isDropdown2Visible) {
                bvEvent.preventDefault();
            }
        });
        this.totalRows = this.itemTest.length;
    },
    watch: {
        paramsValues: {
            handler() {
                this.currentPage = 1;
                this.getData();
            },
            deep: true,
        },
        currentPage: {
            handler: function () {                
                this.getData()
                    .then((res) => {
                        console.log(res);
                        if (res.length < 10) return;
                        this.countRecords = this.countRecords + 20;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
        },
    },
    created() {
        this.getSucursales();
        this.getGeneratedReports();
    },
    methods: {
        setValueTRXNC() {
            this.paramsValues.tipoTRX = "NOTA DE CREDITO";
            this.selectedParams = "i";
            this.selectedParamsText = "Consulta por Tipo TRX";
        },
        setValueTRXVenta() {
            this.paramsValues.tipoTRX = "VENTA";
            this.selectedParams = "i";
            this.selectedParamsText = "Consulta por Tipo TRX";
        },
        setValue(item) {
            this.selectedParams = item.value;
            this.selectedParamsText = item.text;
            this.clearParamsVal();
        },
        async generateExcelFile() {
            try {
                this.isGenerating = true;
                this.isReady = false;
                this.errorMessage = "";
                this.statusMessage =
                "Su reporte está siendo generado y estará disponible en la ruta Consultas/Ver Reportes.";

                const formatedDateInic = this.fechaInicio.replace(/-/g, "");
                const formatedDateFin = this.fechaFin.replace(/-/g, "");

                const payload = {
                Fecha_ini: formatedDateInic,
                Fecha_fin: formatedDateFin,
                Local: this.sucursal || null,
                Pos: this.paramsValues?.terminal || null,
                Secuencia: this.paramsValues?.sequence || null,
                SKU: this.paramsValues?.sku || null,
                EAN: this.paramsValues?.ean || null,
                NumCta: this.paramsValues?.cuenta || null,
                NumDoc: this.paramsValues?.docIdentidad || null,
                NumNV: this.paramsValues?.nv || null,
                Folio: this.paramsValues?.folio || null,
                TipoTRX: this.paramsValues?.tipoTRX || null,
                };

                await axios.get(
                `${process.env.VUE_APP_URL_API}/v1/sales/excel/enqueue`,
                { params: payload }
                );

                this.isGenerating = false;
            } catch (error) {
                console.error(error);
                this.errorMessage = "Error encolando Excel: " + error.message;
                this.isGenerating = false;
            }
        },
        async getGeneratedReports() {
            try {
                const { data } = await axios.get(
                    `${process.env.VUE_APP_URL_API}/v1/sales/excel/links`
                );

                // data es un array de links
                this.generatedReports = data;
            } catch (error) {
                console.error("Error obteniendo reportes generados:", error);
                this.generatedReports = [];
            }
        },
        clearParamsVal() {
            this.paramsValues.sku = "";
            this.paramsValues.cuenta = "";
            this.paramsValues.nv = "";
            this.paramsValues.docIdentidad = "";
            this.paramsValues.ean = "";
            this.paramsValues.tipoTRX = "";
            this.paramsValues.folio = "";
        },
        async getSucursales() {
            try {
                let response = await axios.get(
                    process.env.VUE_APP_URL_API_STORE + "/v1/store"
                );
                const data = response.data.map((row) => {
                    return {
                        value: row.org_lvl_number,
                        text: row.org_lvl_number + "-" + row.org_name_full,
                    };
                });
                this.optionStores = data;
                //this.detailsOS = response.data;
            } catch (error) {
                console.log(error);
            }
        },
        async getData() {
            this.$store.commit("SET_LOADING", true);
            try {
                this.isBusy = true;
                let formatedDateInic = this.fechaInicio.replace(/-/g, "");
                let formatedDateFin = this.fechaFin.replace(/-/g, "");
                let response = await axios.get(
                    process.env.VUE_APP_URL_API +
                    "/v1/sales?Fecha_ini=" +
                    formatedDateInic +
                    "&Fecha_fin=" +
                    formatedDateFin +
                    "&Local=" +
                    this.sucursal +
                    "&Pos=" +
                    this.paramsValues.terminal +
                    "&Secuencia=" +
                    this.paramsValues.sequence +
                    "&SKU=" +
                    this.paramsValues.sku +
                    "&EAN=" +
                    this.paramsValues.ean +
                    "&NumCta=" +
                    this.paramsValues.cuenta +
                    "&NumDoc=" +
                    this.paramsValues.docIdentidad +
                    "&NumNV=" +
                    this.paramsValues.nv +
                    "&Folio=" +
                    this.paramsValues.folio +
                    "&TipoTRX=" +
                    this.paramsValues.tipoTRX +
                    "&page=" +
                    this.currentPage +
                    "&limit=" +
                    this.limit
                );
                this.itemTest = response.data;
                return response.data;

                //this.detailsOS = response.data;
            } catch (error) {
                console.log(error);
            } finally {
                this.isBusy = false;
                this.$store.commit("SET_LOADING", false);
            }
        },
        async getDetails(item) {
            let formatedDate = item.heD_FCONTABLE.replace(/-/g, "");
            let day = formatedDate.substring(0, 2);
            let month = formatedDate.substring(2, 4);
            let year = formatedDate.substring(4, 8);
            let dateCon = year + month + day;
            this.$router.push({
                name: "Details",
                params: {
                    id: item.heD_NUMTRX,
                    date: dateCon,
                    local: item.heD_LOCAL,
                    pos: item.heD_POS,
                },
            });
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`;
            this.infoModal.content = JSON.stringify(item, null, 2);
            this.$root.$emit("bv::show::modal", this.infoModal.id, button);
        },
        resetInfoModal() {
            this.infoModal.title = "";
            this.infoModal.content = "";
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
    },
    beforeDestroy() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
        }
    },
};
</script>

<style scoped>
.box {
    display: flex;
    align-items: center;
    justify-content: center;
}

.padding-seven-lr {
    padding-right: 20px;
    padding-left: 20px;
}

.hidden-icon {
    display: flex;
}

.padding-none-lr {
    padding: 0;
}

.center-div {
    position: absolute;
    position: relative;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}

.text-large {
    font-size: 1rem !important;
}

.border-none {
    border-color: transparent;
}

.padding-ten-lr {
    padding-left: 76px !important;
}

::v-deep .btn-to {
    background: white !important;
    color: black !important;
    border: 1.3px solid#FF7200;
    outline: none;
    border-radius: 13px;
    font-size: 1.1rem;
}

.text-left {
    text-align: left;
}

::v-deep .page-item.active .page-link {
    background: #ff6e00 !important;
    border-color: #ff6e00 !important;
    color: white !important;
}

::v-deep .page-item.disabled .page-link {
    background: transparent !important;
    border-color: transparent !important;
    font-size: 28px;
}

ul {
    display: flex;
    align-items: center;
}

.padding-five-tb {
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 12px;
}

.padding-five-bottom {
    padding-bottom: 18px;
    padding-top: 14px;
}

.show-xs {
    display: none;
}

.padding-two-bottom {
    padding-bottom: 12px;
}

.center-col {
    float: none;
    margin-left: auto;
    margin-right: auto;
}

.op-84 {
    color: rgb(120, 120, 120);
}

.btn-transparent {
    background: transparent !important;
    color: gray !important;
    border: none !important;
    border-radius: 0;
}

.text-med {
    font-size: 1.15rem;
}

.padding-nine-lr {
    padding-left: 3%;
    padding-right: 3%;
    padding-top: 2%;
    padding-bottom: 2%;
}

.btn-transparent:active {
    border-bottom: 1.5px solid #ff7a00 !important;
}

.box-shadow-light {
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
}

.btn-transparent:focus {
    border-bottom: 1.5px solid #ff7a00 !important;
    box-shadow: none !important;
}

.collapsed>.when-opened,
:not(.collapsed)>.when-closed {
    display: none;
}

@media (max-width: 575.98px) {
    ::v-deep .btn-to {
        font-size: 14px;
    }

    .padding-six-xs {
        padding-bottom: 2%;
    }

    .none-xs {
        display: none;
    }

    .form-control-lg {
        width: 100% !important;
        font-size: 1.1rem;
        padding: 0.375rem 0.75rem;
    }

    .card {
        border: none !important;
        width: 100%;
    }

    ::v-deep .table.b-table.show-xs>tbody>tr>[data-label]>div {
        width: 100% !important;
        display: inline-flex !important;
    }

    .hidden-xs {
        display: none !important;
    }

    .show-xs {
        visibility: visible;
        display: -webkit-box;
    }

    .hidden-icon {
        display: none;
    }

    .width-1000 {
        width: 100%;
        text-align: center !important;
    }

    .show-icon {
        visibility: visible;
        padding-right: 4px;
    }

    table.b-table.b-table-stacked-md>tbody>tr>td>div {
        width: 100% !important;
        display: inline-flex !important;
    }

    .table.b-table.b-table-stacked-md>tbody>tr>div {
        width: 100% !important;
        display: inline-flex !important;
    }
}

.visibility-hidden {
    visibility: hidden;
}

.form-control-lg {
    width: 11rem;
    font-size: 1.1rem;
    padding: 0.375rem 0.75rem;
}

.form-control-auto {
    width: 100% !important;
}

input[type="date"]:before {
    content: attr(placeholder) !important;
    color: #aaa;
    width: 83px;
}

input[type="date"]:focus:before,
input[type="date"]:valid:before {
    content: "";
    width: auto;
}

.width-100 {
    width: 100%;
}

.margin-two-top {
    margin-top: 10px;
}

.card {
    background: transparent;
    border: none;
    padding-left: 15px;
}

.bg-grey {
    background: #f0f0f0;
}

.bg-grey-btn {
    background: #676767;
    color: white;
}

.bg-orange-btn {
    background: #ff7a00;
    color: white;
    border-color: transparent !important;
    border-radius: 37px;
    font-size: 1.1rem;
}

.bg-orange-btn:hover {
    color: #ff7a00;
    background: white;
    border-color: #ff7a00 !important;
}

.border-radius-20 {
    border-radius: 20px;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.05);
}

input[type="date"]:required:invalid::-webkit-datetime-edit {
    color: transparent;
}

::v-deep .page-item.active .page-link {
    background: rgb(254, 123, 1);
    border-color: rgb(254, 123, 1);
}

::v-deep .table-striped tbody tr:nth-of-type(odd) {
    background-color: #fff8f2;
    border-color: transparent;
}

::v-deep .table td {
    border-color: transparent !important;
    color: #676767;
}

.card-body {
    padding: 0.75rem !important;
}

.btn-orange-tra {
    background: white;
    color: rgb(254, 123, 1);
    border-color: rgb(254, 123, 1);
    border-radius: 37px;
}

.btn-orange-tra:hover {
    color: white;
    background: #ff7200;
    border-color: transparent;
}

.form-control {
    border: 1.3px solid#FF7200;

    outline: none;
    border-radius: 13px;
}

.custom-select {
    border: 1.3px solid#FF7200;

    color: black !important;
    border-radius: 13px;
    font-size: 1.1rem;
}

::v-deep .page-link {
    color: #676767 !important;
    border-color: transparent;
    font-weight: bold;
    background: transparent !important;
}

::v-deep .page-item button[role="menuitem"] {
    font-size: 28px;
}

::v-deep .b-table thead {
    background-color: transparent !important;
    color: black !important;
    font-weight: 500 !important;
    border: none !important;
}

::v-deep .b-table thead th {
    font-weight: 700 !important;
    border: none !important;
}

::v-deep .b-table td {
    border-bottom: 1px solid rgb(222, 226, 230) !important;
}

.text-center {
    text-align: center;
}

.text-grey {
    color: #676767;
    font-size: 15px;
    letter-spacing: 0px;
    display: block;
    margin-bottom: 0;
}

.bg-white {
    background: white;
}

.color-white {
    color: white;
}

.padding-five-all {
    margin: 15px;
    padding: 19px;
    border-radius: 10px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
}

.visibility-hidden {
    visibility: hidden;
}

.margin-lr-none {
    margin: 0 !important;
}

.padding-five-lr {
    padding-left: 15px;
    padding-right: 25px;
    padding-top: 25px;
}

.custom-select:focus {
    border-color: #ced4da;
    box-shadow: none;
}

.form-control:focus {
    border-color: #ced4da;
    box-shadow: none;
}

.btn-secondary:focus {
    box-shadow: none;
}

.margin-none {
    margin: 0;
}

.color-orange {
    color: #ff7200;
    font-weight: bold;
}

::v-deep .bg-orange {
    background: #ff7200;
}

.hidden_header {
    visibility: hidden;
    border: none !important;
}

.color-gray {
    color: #676767;
    font-weight: bold;
}

.padding-six-right {
    margin-left: 20px;
}

.padding-ten-tb {
    padding-top: 25px;
    padding-bottom: 25px;
}

label {
    color: #676767;
    font-size: 1rem;
}
</style>
